export { FORM_THEME } from './antdTheme';
